import React, { forwardRef, MutableRefObject, useImperativeHandle, useRef, useState } from 'react';

interface DropdownWrapperProps {
  children: React.ReactNode;
  dropDownRef: MutableRefObject<HTMLDivElement>;
  onStatusChanged(status: boolean): void;
}

export interface DropdownImperativeProps {
  close(): void;
}

export const DropdownWrapper = forwardRef<DropdownImperativeProps, DropdownWrapperProps>((
  { children, dropDownRef, onStatusChanged },
  ref
) => {
  const [ dropDownStatus, setDropDownStatus ] = useState(false);
  // tslint:disable-next-line:no-null-keyword
  const headerRef = useRef(null);

  const dropDownClick = status => {
    setDropDownStatus(status);
    onStatusChanged(status);
    if (status) {
      document.addEventListener('mousedown', mouseDownHandler);
    } else {
      document.removeEventListener('mousedown', mouseDownHandler);
    }
  };

  const mouseDownHandler = e => {
    const element = dropDownRef.current;
    const head = headerRef.current;
    const target = e.target;
    if ((!head || !head.contains(target)) && element !== target && element !== null && !element.contains(target)) {
      dropDownClick(false);
    }
  };

  useImperativeHandle(
    ref,
    () => ({
      close: () => {
        dropDownClick(false);
      }
    })
  );

  return (
    <div ref={headerRef} onClick={() => dropDownClick(!dropDownStatus)}>
      {children}
    </div>
  );
});
